<template>
    <section class="IconBlock" :id=block_id>
        <div class="bg-neutral-50">
            <div class="container-block">

                <div class="flex flex-col mb-8 md:mb-12">
                    
                    <!-- Headline -->
                    <h2 class="mb-2 md:mb-3 head-md text-neutral-800">{{ headline }}</h2>

                    <!-- Copy -->
                    <div class="max-w-[50ch] text-neutral-600 body-md">
                        <p>{{ copy }}</p>
                    </div>
                    
                </div>
                
                <!-- Cards -->
                <div class="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
                    
                    <!-- Individual Cards -->
                    <div v-for="card in cards" :key="card.id" class="flex items-start space-x-4">
                    
                        <!-- Icon -->
                        <div class="mt-0.5 flex-shrink-0">
                            <picture>
                                <img loading="lazy" class="w-8 h-8" :src=card.icon alt="Icon">
                            </picture>
                        </div>

                        <div class="flex flex-col items-start flex-grow">

                            <!-- Headline -->
                            <h3 class="mb-1 font-bold body-xl text-neutral-800 ">{{ card.title }}</h3>

                            <!-- Copy -->
                            <div class="body-md text-neutral-600 copy max-w-[45ch]">
                                <p>{{ card.copy }}</p>
                            </div>

                            <!-- CTA -->
                            <div class="mt-2">
                                <a :href=card.cta.url class="btn btn-md btn-link btn-secondary">{{ card.cta.text }}</a>
                            </div>

                        </div>
                    </div>
                    
                </div>

            </div>
        </div>
    </section>
</template>

<script>

    export default {

        name: 'IconBlock',

        props: {
            content: Object, // Hero Content
        },

        data(){
            return {
                block_id: this.content.block_id,
                headline: this.content.headline,
                copy: this.content.copy,
                cards: this.content.cards,
            }
        }
    }

</script>